import { getLabel } from '@weapp/utils';
/*
 * @Author: wangchong
 * @desc: login constants
 */
export const passportClsPrefix = "weapp-passport";
export const MobClsPrefix = "weapp-passport-mobile";
export const LOCATION_ORIGN = `${window.location.protocol}//${window.location.host}`;
// 路由白名单，用于初步筛选自定义登录页地址
export const AppRouteList = [
    'login',
    'signup',
    'passport',
    'adminlogin',
    'bindService',
    'ebBind'
]
// 路由白名单，用于初步筛选自定义登录页地址
export const PCRouteList = [
    'login',
    'signup',
    'passport',
    'adminlogin',
    'ebBind'
]
export const onlyContentRoutes = ['/passport/qyscheck']

// EB组件默认数据-属性
export const EBLOGINCOM_ATTR_CONFIG = () => {
    return {
        buttonPicSize: {
            rate: 1,
            width: 0,
            height: 0,
            type: 'px',
            calcSize: true,
            uploadSize: {//初次上传值
                width: 0,
                height: 0,
                rate: 1
            }
        },
        scanIconType: 'qrcode',
        scanIconPosition_x: {
            dir: `left`,
            value: 0
        },
        scanIconPosition_y: {
            dir: `top`,
            value: 0
        },
        qrIconPosition_x: {
            dir: `left`,
            value: 0
        },
        qrIconPosition_y: {
            dir: `top`,
            value: 0
        },
        buttonPosition_x: {
            dir: `left`,
            value: 0
        },
        buttonPosition_y: {
            dir: `top`,
            value: 0
        },
        langPosition_x: {
            dir: `left`,
            value: 0
        },
        langPosition_y: {
            dir: `top`,
            value: 0
        },
        langSwitch: true,
        langDisplayType: 'icon',
        langDisplayTypeData: [
            { id: "icon", content: getLabel('224048', '图标') },
            { id: "word", content: getLabel('224049', '文字') },
        ],
        privacySwitch: false,
        privacyContent: getLabel('224058', '用户隐私政策协议'),
        privacyHref: `https://www.weaver.com`,
        copyrightSwitch: false,
        copyrightText: `Copyright © 2001-${new Date().getFullYear().toString()} Weaver Network All Rights Reserved`,
        copyrightLinkText: getLabel('159816', '沪ICP备05040488号-9'),
        copyrightLinkHref: `https://beian.miit.gov.cn`
    }
}

export const publicUrl = window.publicUrlstatic || '';
export const publicUrlstatic = window.publicUrlstatic || '';
export const publicUrlapi = window.publicUrlapi || '';
